import { Switch } from '@shared/components/core/field/CommonFieldStyles';
import CommonRow from '@shared/components/core/row/CommonRow';
import { useTranslation } from 'react-i18next';

/** Ties the switch to the row's title, the way the settings rows do. */
const APPROVAL_LABEL_ID = 'mcp-require-approval-label';

export interface IMcpApprovalRowProps {
    requireApproval: boolean;
    disabled?: boolean;
    onToggle: (requireApproval: boolean) => void;
}

/**
 * "Require approval for each tool call", as the same settings-style row the editor and the detail dialog
 * both show: title, explanation, switch on the right. One setting shouldn't be worded or shaped two ways
 * depending on which surface the user reached it from.
 */
export default function McpApprovalRow({ requireApproval, disabled, onToggle }: Readonly<IMcpApprovalRowProps>) {
    const { t } = useTranslation('common');

    return (
        <CommonRow
            title={t('mcp.editor.requireApprovalLabel')}
            titleId={APPROVAL_LABEL_ID}
            description={t('mcp.editor.requireApprovalHelp')}>
            <Switch
                aria-labelledby={APPROVAL_LABEL_ID}
                checked={requireApproval}
                disabled={disabled}
                onChange={(_, value) => onToggle(value)}
            />
        </CommonRow>
    );
}
